import { APP_INITIALIZER, Provider } from "@angular/core";
import { Router } from "@angular/router";
import { UserControllerService } from "./modules/fraud/partials/services/user-controller.service";
import { TranslateService } from "@ngx-translate/core";
import { catchError, map, Observable, tap } from "rxjs";
import { UserEntity } from "./modules/fraud/api/models/fraud.models";
import { parseUrlBotFromStartParam } from "./modules/fraud/partials/helpers/parse-url-start-param";
import { ProjectSettingsService } from "./modules/fraud/partials/services/project-settings.service";

export const appConfigInit: Provider = {
  provide: APP_INITIALIZER,
  useFactory: (router: Router, userControllerService: UserControllerService, translateService: TranslateService, projectSettingsService: ProjectSettingsService) => {
    return (): Observable<boolean | UserEntity> | Promise<boolean> => {
      let url: URL = new URL(window.location.href);

      const stringUrl: string = String(url);
      const hasStartParam = stringUrl.includes('start_param');
      const test = 'query_id=AAGr68YUAwAAAKvrxhSU33RL&user=%7B%22id%22%3A6791031723%2C%22first_name%22%3A%22Oskar%20%F0%9F%92%A0%22%2C%22last_name%22%3A%22QA%22%2C%22username%22%3A%22osckar_qa%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FuDf7YB8oS2yew9uOUnbEiZZzy6Wo4NSYCfUEX26RWMUJT3nyIK_1tnoxItjbhuAf.svg%22%7D&auth_date=1753355087&signature=l9P0jH4ztdjkga3uxU-VwX0Ijl8XIrDLedw2nNCHhyjRC1eL0_d5VFYX9ZQo6-7ostB4YhovClVEv2otZSygDQ&hash=a67a46ed29818a01632b48f021c9ea795696d6ad0a7ac805491386ddf7d4258b'

      const getTelegramInitData = window.Telegram.WebApp.initData;
      if (getTelegramInitData) {
        localStorage.setItem('authTelegramData', getTelegramInitData);
      }

      const telegramInitDataLocalStorage: string | null = localStorage.getItem('authTelegramData');

      translateService.use('en');
      const telegramData = getTelegramInitData || telegramInitDataLocalStorage;
      if (!telegramData) {
        return router.navigate(['401']);
      }

      return userControllerService.getUser().pipe(
        tap(async (user: UserEntity | undefined) => {
          if (!user) {
            await router.navigate(['401']);
            return;
          }
          projectSettingsService.load();
          const supportLocales = ['en', 'ru'];
          const { locale } = user.user;
          translateService.addLangs(supportLocales);
          translateService.use(supportLocales.includes(locale) ? locale : 'en');
          if (hasStartParam) {
            const queryParamsWithCustom = parseUrlBotFromStartParam(stringUrl);
            const { path, ...queryParams } = queryParamsWithCustom;
            router.navigate([`/${path}`], { queryParams });
          }
        }),
        map(Boolean),
        catchError(() => {
          return router.navigate(['401']);
        }));
    }
  },
  deps: [
    Router,
    UserControllerService,
    TranslateService,
    ProjectSettingsService
  ],
  multi: true
};
